import { render, staticRenderFns } from "./CredentialerSearch.vue?vue&type=template&id=4cb83b3c"
import script from "./CredentialerSearch.vue?vue&type=script&lang=js"
export * from "./CredentialerSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports